import { ContactBook, Teacher } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    selectedTeachers: []
  },
  actions: {
    async sendMarkNotification(_, params) {
      await ContactBook.sendMarkNotification(params)
    },
    async sendDailyViolation(_, params) {
      await ContactBook.sendDailyViolation(params)
    },
    async sendTuitionFeePeriodNoti(_, params) {
      await ContactBook.sendTuitionFeePeriodNoti(params)
    },
    sendTuitionFeePeriod(_, params) {
      return ContactBook.sendTuitionFeePeriod(params)
    },
    getProgressTuitionFeePeriod(_, params) {
      return ContactBook.getProgressTuitionFeePeriod(params)
    },
    sendSalaryPeriodNoti(_, params) {
      return ContactBook.sendSalaryPeriodNoti(params)
    },
    getProgressSalaryPeriodNoti(_, params) {
      return ContactBook.getProgressSalaryPeriodNoti(params)
    },
    async fetchTeacherByCodeToSelectedList({ commit }, params) {
      const res = await Teacher.findByCodes(params)
      commit('setSelectedTeachers', res)
    }
  },
  mutations: {
    setSelectedTeachers(state, selected = []) {
      state.selectedTeachers = selected
    }
  },
  getters: {}
}
